const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA2ImLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.29 34.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "FOwpIA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#fff"
    },
    points: "145.29 .01 145.29 34.15 134.08 34.15 134.08 15.73 125.07 26.21 116.06 15.73 116.06 34.15 104.85 34.15 104.85 .01 116.13 .01 125.07 10.49 134.01 .01 145.29 .01"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M51.36,24.37h24.69v9.92h-35.9c.12-3.44-.15-6.99,0-10.42.65-14.92,14.4-10.39,24.87-11.29.94-.12,1.27-1.47.61-2.1-.09-.09-.79-.42-.86-.42h-23.48V.15h24.91c7.92.44,11.92,4.95,10.83,12.94-1.58,11.57-15.51,7.95-23.61,8.58-1.93.15-2.17.81-2.05,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0,34.15L15.96.15l12.78-.15.22.1,9.74,20.84-.11,13.21h-5.53l-1.97-4.45-17.09-.07-2.29,4.51H0ZM26.67,20.69l-4.12-9.21-4.4,9.21h8.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M103.29.15v9.92h-9.51v14.09l.21.21h9.29v9.92h-25.68v-9.92h4.97v-14.31h-3.83c-.24-3.53-1.26-6.63-4.13-8.84-.38-.29-.84-.5-1.22-.76-.13-.09-.26.02-.19-.32h30.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2ImLight);
export default __webpack_public_path__ + "static/media/A2IM-Light.f5a0a3bc9c1f6024f495c0d6a8330ae6.svg";
export { ForwardRef as ReactComponent };